import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom";
import { Button, Box, Text, TableCell, TableRow, TableHeader, TableBody, Table, Anchor } from 'grommet';
/*import data from '../Data.json';*/
import { EboxRequestCtrl } from '../Controllers/Ebox/EboxRequestCtrl';
import ModalErrorTimeout from './ModalErrorTimeout';
import { loader } from '../Utils/Utility';


class GestioneRichiesteStep2 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            search: '',
            selected: {},
            value: [],
            codes: [],
            selectedType: '',
            selectedUser: '',
            selectedPV: '',
            selectedCode: '',
            setEmail: [],
            email: '',
            masgemail: '',
            openModal: false,
            openModalemail: false,
            openModalpoint: false,
            showGestore: true,
            showGestori: false,
            showTimeoutModal: false,
            practicestate: '',
            loading: true
        }
        this.openPratiche = this.openPratiche.bind(this);
    }


    componentWillMount() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
		const self=this;
		EboxRequestCtrl(function(data, status) {
			self.setState({
				data: data === undefined ? [] : data,
				//pagination: data.pagination,
				//status: status,
				loading:false
			});
		}, function(error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                } 
            })
		}, this.props.values.gestore, token, ids);
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    openPratiche(event) {
        event.preventDefault();
        if (event.target.id === 'nuove') {
            this.props.history.push({
                //practicestate: 'new'
                practicestate: 'nuove'
              })
            this.props.nextStep();
        }
        else if (event.target.id === 'sospeso') {
            this.props.history.push({
                //practicestate: "suspended"
                practicestate: 'sospeso'
              })
            this.props.nextStep();
        }
        else if (event.target.id === 'scadenza') {
            this.props.history.push({
                //practicestate: "expired"
                practicestate: "scadenza"
              })
            this.props.nextStep();
        }
        else if (event.target.id === 'visione') {
            this.props.history.push({
                //practicestate: "viewed"
                practicestate: "visione"
              })
            this.props.nextStep();
        }
        else if (event.target.id === 'annullate') {
            this.props.history.push({
                //practicestate: "canceled"
                practicestate: "annullate"
              })
            this.props.nextStep();
        }
        else if (event.target.id === 'evase') {
            this.props.history.push({
                //practicestate: "completed"
                practicestate: "evase"
              })
            this.props.nextStep();
        }
        else if (event.target.id === 'chiuse') {
            this.props.history.push({
                //practicestate: "closed"
                practicestate: "chiuse"
              })
            this.props.nextStep();
        }
    }

    render() {
        
        return (
            <Box className='contentbox'>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='start' style={{ margin: '20px 22px' }}>
                    <Text className='titlehome'><h1>RICHIESTE DOCUMENTAZIONE - GESTIONE RICHIESTE DISPUTE ONLINE</h1></Text>
                    <Text className='subtitlehome'><h3>Per accedere ai dettagli, clicca sullo stato che ti interessa</h3></Text>
                </Box>

                {this.state.loading ? 
                    
                    loader

                :
                
                <Box align='start' style={{ margin: '16px' }}>

                    <Box style={{ width: '100%' }}>
                        <Box>
                            <Text style={{ fontFamily: 'Segoe UI Semibold' }} textAlign='start'>Pratiche in attesa</Text>
                        </Box>


                        <Box>
                            <Table>
                                <TableHeader>
                                    <TableRow >
                                        <TableCell scope="col" border="bottom">
                                            Stato
                                        </TableCell>
                                        <TableCell scope="col" border="bottom">
                                            Numero pratiche
                                        </TableCell>
                                    </TableRow>
                                </TableHeader>
                                <TableBody className="statusTable">
                                    <TableRow>
                                        <TableCell scope="row">
                                            {this.state.data.new > 0 ?
                                                <Anchor id='nuove' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>Nuove</Anchor>
                                                : "Nuove"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.new}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell scope="row">
                                            {this.state.data.suspended > 0 ?
                                                <Anchor id='sospeso' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>In sospeso</Anchor>
                                                : "In sospeso"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.suspended}
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell scope="row">
                                            {this.state.data.expired > 0 ?
                                                <Anchor id='scadenza' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>In scadenza</Anchor>
                                                : "In scadenza"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.expired}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>



                    <Box style={{ width: '100%' }}>
                        <Box>
                            <Text style={{ fontFamily: 'Segoe UI Semibold' }} textAlign='start'>Pratiche in elaborazione</Text>
                        </Box>
                        <Box>
                            <Table>

                                <TableHeader>
                                    <TableRow>
                                        <TableCell scope="col" border="bottom">
                                            Stato
                                                </TableCell>
                                        <TableCell scope="col" border="bottom">
                                            Numero pratiche
                                                </TableCell>
                                    </TableRow>
                                </TableHeader>
                                <TableBody className="statusTable">

                                    <TableRow>
                                        <TableCell scope="row">
                                            {this.state.data.viewed > 0 ?
                                                <Anchor id='visione' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>In visione</Anchor>
                                                : "Visione"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.viewed}
                                        </TableCell>

                                    </TableRow>

                                </TableBody>
                            </Table>
                        </Box>
                    </Box>



                    <Box style={{ width: '100%' }}>
                        <Box>
                            <Text style={{ fontFamily: 'Segoe UI Semibold' }} textAlign='start'>Pratiche lavorate</Text>
                        </Box>
                        <Box>
                            <Table>
                                <TableHeader>
                                    <TableRow >
                                        <TableCell scope="col" border="bottom">
                                            Stato
                                        </TableCell>
                                        <TableCell scope="col" border="bottom">
                                            Numero pratiche
                                        </TableCell>
                                    </TableRow>
                                </TableHeader>
                                <TableBody className="statusTable">
                                    <TableRow>
                                        <TableCell scope="row">
                                            {this.state.data.canceled > 0 ?
                                                <Anchor id='annullate' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>Annullate</Anchor>
                                                : "Annullate"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.canceled}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell scope="row">
                                            {this.state.data.completed > 0 ?
                                                <Anchor id='evase' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>Evase</Anchor>
                                                : "Evase"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.completed}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell scope="row">
                                        {this.state.data.closed > 0 ?
                                            <Anchor id='chiuse' href='' style={{ fontFamily: 'Segoe UI Semibold' }} onClick={this.openPratiche}>Chiuse</Anchor>
                                            : "Chiuse"}
                                        </TableCell>
                                        <TableCell scope="row">
                                            {this.state.data.closed}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>
                    <Box id='legenda' alignSelf='center' style={{ width: '100%' }} justify='center' >
                        <Box>
                            <Box>
                                <Text textAlign='start'>PRATICHE IN ATTESA</Text>
                            </Box>
                            <Box direction='row'>
                                <Box style={{ width: '30%' }}>
                                    <Text>Nuova:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>Nuove richiesta documentazione</Text>
                                </Box>
                            </Box>
                            <Box direction='row'>
                                <Box style={{ width: '30%' }}>
                                    <Text>In sospeso:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>	Sollecito o richieste di ulteriore documentazione</Text>
                                </Box>
                            </Box>
                            <Box direction='row'>
                                <Box style={{ width: '30%' }}>
                                    <Text>In scadenza:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>Richieste documentazione da evadere urgentemente</Text>
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Box>
                                <Text textAlign='start'>PRATICHE IN ELABORAZIONE</Text>
                            </Box>
                            <Box direction='row' >
                                <Box style={{ width: '30%' }}>
                                    <Text>In visione:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>Documentazione pervenuta ed in esame</Text>
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Box>
                                <Text textAlign='start'>PRATICHE LAVORATE</Text>
                            </Box>
                            <Box direction='row' >
                                <Box style={{ width: '30%' }}>
                                    <Text>Annullate:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>Annullate da American Express</Text>
                                </Box>
                            </Box>
                            <Box direction='row' >
                                <Box style={{ width: '30%' }}>
                                    <Text>Evase:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>Documentazione ricevuta</Text>
                                </Box>
                            </Box>
                            <Box direction='row' >
                                <Box style={{ width: '30%' }}>
                                    <Text>Chiuse:</Text>
                                </Box>
                                <Box style={{ width: '70%' }}>
                                    <Text>Documentazione non pervenuta, insufficiente o incompleta</Text>
                                </Box>
                            </Box>
                        </Box>

                    </Box>
                    <Box align='center'>
                        <Button className='btnform' style={{ width: '170px', margin: '32px 30px 0 0' }} onClick={this.back}>INDIETRO</Button>
                    </Box>
                </Box>
            }
            </Box>

        )
    }
}

export default GestioneRichiesteStep2 = withRouter(GestioneRichiesteStep2)
